(function () {

  function styleShopifyForms() {

    const embeds = document.querySelectorAll('shopify-forms-embed');

    embeds.forEach((embed) => {

      const root = embed.shadowRoot;
      if (!root) return;

      const formWrapper = root.querySelector(
        '[data-sizing="form-wrapper"]'
      );

      if (!formWrapper) return;

      const isMobile = window.innerWidth <= 749;


      /* ========================================
         POPUP SIZE
      ======================================== */

      if (isMobile) {

        formWrapper.style.setProperty(
          'width',
          '94vw',
          'important'
        );

        formWrapper.style.setProperty(
          'max-width',
          '94vw',
          'important'
        );

        formWrapper.style.setProperty(
          '--container-max-w',
          '94vw',
          'important'
        );

        formWrapper.style.setProperty(
          'max-height',
          '92vh',
          'important'
        );

        formWrapper.style.setProperty(
          'overflow-y',
          'auto',
          'important'
        );

      } else {

        formWrapper.style.setProperty(
          'width',
          '800px',
          'important'
        );

        formWrapper.style.setProperty(
          'max-width',
          '90vw',
          'important'
        );

        formWrapper.style.setProperty(
          '--container-max-w',
          '800px',
          'important'
        );

        formWrapper.style.removeProperty('max-height');
        formWrapper.style.removeProperty('overflow-y');
      }


      /* ========================================
         VECHOUSE STYLES
      ======================================== */

      if (!root.querySelector('#vechouse-form-styles')) {

        const style = document.createElement('style');

        style.id = 'vechouse-form-styles';

        style.textContent = `


          /* ====================================
             BACKGROUND
          ==================================== */

          [data-sizing="form-wrapper"],
          [data-sizing="form-wrapper"] > div,
          form {
            background-color: #eae5df !important;
          }



          /* ====================================
             DESKTOP TITLE
          ==================================== */

          h1,
          h2 {
            font-family:
              Impact,
              "Arial Narrow",
              Arial,
              sans-serif !important;

            font-size: 39px !important;
            font-weight: 400 !important;

            letter-spacing: -0.7px !important;
            line-height: 0.88 !important;

            text-transform: uppercase !important;
          }



          /* SUBSCRIBE */

          .vechouse-subscribe {
            display: block !important;

            font-family:
              Impact,
              "Arial Narrow",
              Arial,
              sans-serif !important;

            font-size: 1.28em !important;
            font-weight: 400 !important;

            line-height: 0.86 !important;
            letter-spacing: -1px !important;

            color: #000000 !important;

            white-space: nowrap !important;
          }



          /* & GET 10% OFF */

          .vechouse-offer-line {
            display: block !important;

            font-family:
              Impact,
              "Arial Narrow",
              Arial,
              sans-serif !important;

            font-size: 1em !important;
            font-weight: 400 !important;

            line-height: 0.90 !important;
            letter-spacing: -0.7px !important;

            color: #000000 !important;

            white-space: nowrap !important;
          }



          /* 10% OFF */

          .vechouse-discount {
            color: #861f3a !important;
          }



          /* ====================================
             SUBTITLE
          ==================================== */

          h1 + p,
          h2 + p {
            font-family:
              Arial,
              Helvetica,
              sans-serif !important;

            font-size: 11px !important;
            font-weight: 400 !important;

            letter-spacing: 3.2px !important;
            line-height: 1.3 !important;

            text-transform: uppercase !important;

            color: #000000 !important;
          }



          /* ====================================
             INPUTS

             IMPORTANT:
             We do NOT change their dimensions.
          ==================================== */

          input {
            font-family:
              Arial,
              Helvetica,
              sans-serif !important;
          }



          /* ====================================
             BUTTON

             IMPORTANT:
             We do NOT change its dimensions.
          ==================================== */

          button[type="submit"] {
            font-family:
              Arial,
              Helvetica,
              sans-serif !important;

            font-size: 11px !important;
            font-weight: 700 !important;

            letter-spacing: 1.8px !important;

            text-transform: uppercase !important;
          }



          /* ====================================
             MOBILE
          ==================================== */

          @media (max-width: 749px) {


            /* ----------------------------------
               IMAGE
            ---------------------------------- */

            [data-sizing="form-wrapper"] img {
              width: 100% !important;

              height: 195px !important;
              max-height: 195px !important;

              object-fit: cover !important;

              object-position:
                center 35% !important;

              display: block !important;
            }



            /* ==================================
               TITLE CONTAINER

               Force the two title lines to be
               independent rows.
            ================================== */

            h1,
            h2 {
              display: flex !important;

              flex-direction: column !important;

              align-items: center !important;
              justify-content: center !important;

              width: 100% !important;
              max-width: 100% !important;

              box-sizing: border-box !important;

              margin:
                -5px 0 0 0 !important;

              padding:
                0 !important;

              text-align:
                center !important;

              line-height:
                1 !important;
            }



            /* ==================================
               LINE 1

               SUBSCRIBE

               This is deliberately larger.
            ================================== */

            .vechouse-subscribe {
              display: block !important;

              flex:
                0 0 auto !important;

              width:
                100% !important;

              max-width:
                100% !important;

              box-sizing:
                border-box !important;

              margin:
                0 !important;

              padding:
                0 !important;

              text-align:
                center !important;

              font-size:
                34px !important;

              line-height:
                0.90 !important;

              letter-spacing:
                -0.8px !important;

              white-space:
                nowrap !important;

              color:
                #000000 !important;
            }



            /* ==================================
               LINE 2

               & GET 10% OFF

               One single centered line.
            ================================== */

            .vechouse-offer-line {
              display: block !important;

              flex:
                0 0 auto !important;

              width:
                100% !important;

              max-width:
                100% !important;

              box-sizing:
                border-box !important;

              margin:
                3px 0 0 0 !important;

              padding:
                0 !important;

              text-align:
                center !important;

              font-size:
                25px !important;

              line-height:
                0.95 !important;

              letter-spacing:
                -0.8px !important;

              white-space:
                nowrap !important;

              color:
                #000000 !important;
            }



            /* 10% OFF */

            .vechouse-discount {
              display:
                inline !important;

              color:
                #861f3a !important;

              white-space:
                nowrap !important;
            }



            /* ==================================
               LINE 3

               ON YOUR FIRST ORDER
            ================================== */

            h1 + p,
            h2 + p {
              display:
                block !important;

              width:
                100% !important;

              max-width:
                100% !important;

              box-sizing:
                border-box !important;

              margin:
                6px 0 0 0 !important;

              padding:
                0 !important;

              text-align:
                center !important;

              font-size:
                9px !important;

              line-height:
                1 !important;

              letter-spacing:
                1.8px !important;

              white-space:
                nowrap !important;

              color:
                #000000 !important;
            }



            /* ==================================
               INPUTS

               DO NOT CHANGE SIZE
            ================================== */

            input {
              height:
                auto !important;

              min-height:
                unset !important;
            }



            /* ==================================
               BUTTON

               DO NOT CHANGE SIZE
            ================================== */

            button[type="submit"] {
              height:
                auto !important;

              min-height:
                unset !important;

              font-size:
                12px !important;

              letter-spacing:
                1.8px !important;
            }

          }

        `;

        root.appendChild(style);
      }



      /* ========================================
         REBUILD TITLE

         Shopify originally gives us:
         SUBSCRIBE & GET 10% OFF

         We replace it with two explicit elements.
      ======================================== */

      const headings =
        root.querySelectorAll('h1, h2');

      headings.forEach((heading) => {

        const currentText =
          heading.textContent
            .replace(/\\s+/g, ' ')
            .trim()
            .toUpperCase();


        if (
          currentText ===
            'SUBSCRIBE & GET 10% OFF' &&
          !heading.dataset.vechouseStyled
        ) {

          heading.innerHTML = `

            <span class="vechouse-subscribe">
              SUBSCRIBE
            </span>

            <span class="vechouse-offer-line">
              &amp; GET <span class="vechouse-discount">10% OFF</span>
            </span>

          `;

          heading.dataset.vechouseStyled =
            'true';
        }

      });

    });

  }



  /* ============================================
     OBSERVER
  ============================================ */

  function initFormsObserver() {

    styleShopifyForms();

    const observer =
      new MutationObserver(() => {
        styleShopifyForms();
      });

    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );

    window.addEventListener(
      'resize',
      styleShopifyForms
    );
  }



  /* ============================================
     START
  ============================================ */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initFormsObserver
    );

  } else {

    initFormsObserver();

  }

})();